import { Avatar, Card, Col, Divider, Row, Show, Space, Tag, Typography } from '@pankod/refine-antd';
import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import defaultAvatar from 'assets/images/default-avatar.jpg';
import { AddressShow, PageHeader, PaymentMethodsTable, SupplierReportTable } from 'components';
import { PointOfContactTable } from 'components/point-of-contact';
import { ISupplier } from 'interfaces';

const { Title, Text } = Typography;

export const SupplierShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<ISupplier>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'supplierCode',
        'mobileNumber',
        {
          address: ['street', 'area', 'city', 'country', 'zip'],
        },
        {
          supplierPhoto: [
            {
              avatar: ['url', 'thumbUrl'],
            },
          ],
        },
        {
          supplierTags: [
            {
              tag: ['id', 'name'],
            },
          ],
        },
      ],
    },
  });
  const { data, isLoading: isSupplierLoading } = queryResult;
  const record = data?.data;
  const supplierPhoto = record?.supplierPhoto;
  const supplierTags = record?.supplierTags || [];
  let avatarURL;
  if (supplierPhoto instanceof Array) {
    avatarURL = supplierPhoto[supplierPhoto?.length - 1]?.avatar?.url;
  }

  const tags = supplierTags.map((tagObj) => (
    <Tag key={tagObj.tag.id} color="default">
      {tagObj.tag.name}
    </Tag>
  ));

  return (
    <>
      <Show headerProps={{ extra: <PageHeader path="/suppliers" /> }}>
        <Row gutter={[48, 32]} wrap>
          <Col xs={{ span: 24, order: 2 }} lg={{ span: 17, order: 1 }}>
            <Card loading={isSupplierLoading} title="Information">
              <Title level={5}>Name</Title>
              <Text>{record?.name}</Text>
              <Title level={5}>Email</Title>
              <Text>{record?.email}</Text>
              <Title level={5}>Mobile Number</Title>
              <Text>{record?.mobileNumber}</Text>
              <Title level={5}>Supplier Code</Title>
              <Text>{record?.supplierCode}</Text>
              <Title level={5}>Tags</Title>
              <div style={{ marginBottom: '1.3rem' }}>{tags}</div>
            </Card>
            <Card loading={isSupplierLoading} title="Address" style={{ marginTop: '32px' }}>
              <AddressShow
                street={record?.address?.street}
                area={record?.address?.area}
                city={record?.address?.city}
                country={record?.address?.country}
                zip={record?.address?.zip}
              />
            </Card>
          </Col>

          <Col xs={{ span: 24, order: 1 }} lg={{ span: 7, order: 2 }}>
            <Card
              style={{
                backgroundColor: '#FAFAFA',
                opacity: 1,
              }}
              bodyStyle={{ height: '300px' }}
            >
              <Space
                direction="vertical"
                align="center"
                style={{
                  width: '100%',
                  textAlign: 'center',
                  margin: '26px 0 30px 0',
                }}
              >
                <Avatar
                  src={isSupplierLoading ? defaultAvatar : avatarURL ? avatarURL : defaultAvatar}
                  alt={`Avatar`}
                  size={200}
                  style={{ objectFit: 'cover' }}
                />
              </Space>
            </Card>
          </Col>
        </Row>

        {/* Supplier Reports right after the details card */}
        <Row wrap={false} style={{ marginTop: '32px' }}>
          <Col flex="auto">
            {record?.id && <SupplierReportTable supplierId={record?.id} />}
          </Col>
        </Row>
      </Show>

      <Divider />
      {/* point of contacts table */}
      <Row wrap={false}>
        <Col flex="auto">
          {record?.id && <PointOfContactTable resource="supplier" resourceId={record?.id} />}
        </Col>
      </Row>

      <Divider />
      {/* payments methods */}
      <Row wrap={false}>
        <Col flex="auto">
          {record?.id && <PaymentMethodsTable resource="supplier" resourceId={record?.id} />}
        </Col>
      </Row>
    </>
  );
};
